








































import { Component, Mixins, } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { WindowCloser } from "../../../system/WindowCloser";
import DialogMixin from "../../system/mixins/DialogMixin.vue";

@Component
export default class AccountDialog extends Mixins(DialogMixin) {
  data() {
    return {
      isProcessing: false,
      currentPassword: "",
      newPassword: "",
      newPasswordForVerify: "",
    };
  }
  isProcessing: boolean;
  currentPassword: string;
  newPassword: string;
  newPasswordForVerify: string;

  async show(): Promise<void> {
    this.currentPassword = "";
    this.newPassword = "";
    this.newPasswordForVerify = "";
    return this.showModal(async () => {
      await this.waitHidden();
    });
  }

  async updatePassword(): Promise<void> {
    if (!this.currentPassword) {
      this.$warn("パスワード変更", "現在のパスワードを入力してください。");
      return;
    }
    if (!this.newPassword) {
      this.$warn("パスワード変更", "新しいパスワードを入力してください。");
      return;
    }
    if (!this.newPasswordForVerify) {
      this.$warn("パスワード変更", "新しいパスワード(確認)を入力してください。");
      return;
    }
    if (this.newPassword !== this.newPasswordForVerify) {
      this.$warn("パスワード変更", "パスワードが確認用に入力したものと異なっています。");
      return;
    }
    this.isProcessing = true;
    try {
      const repo = DomainRegistry.account.getAccountRepository();
      const result = await repo.updatePassword(this.currentPassword, this.newPassword);
      if (result.isCurrentPasswordInvalid) {
        this.$warn("パスワード変更", "入力された現在のパスワードが一致しませんでした。");
        return;
      }
      if (result.isOk) {
        this.$success("パスワード変更", "パスワードを変更しました。");
        this.currentPassword = "";
        this.newPassword = "";
        this.newPasswordForVerify = "";
      } else {
        throw new Error("パスワード変更に失敗しました。");
      }
    } catch (e) {
      this.$error("パスワード変更", "パスワードの変更処理中にエラーが発生しました。", e);
    } finally {
      this.isProcessing = false;
    }
  }

  async deleteAccount(): Promise<void> {
    const isConfirmed = await this.confirmDeleteAccount();
    if (!isConfirmed) { return; }

    this.isProcessing = true;
    try {
      const repo = DomainRegistry.account.getAccountRepository();
      await repo.deleteAccount();

      this.$success("アカウント削除", "アカウントを削除しました。");

      // 編集中情報をクリアする必要があればクリアする
      try {
        await WindowCloser.closeHandler();
      } catch (e) {
        // エラーを表示しても操作しようがないので表示しない
        console.error(e);
      }

      this.isProcessing = false;
      this.isVisible = false;

      // TODO: nextTickは無いほうがよいのか有るほうがよいのか？
      this.$nextTick(() => {
        this.$router.replace({
          path: "/Login",
        });
      });
    } catch (e) {
      this.$error("アカウント削除", "アカウントの削除処理中にエラーが発生しました。", e);
    } finally {
      this.isProcessing = false;
    }
  }

  private async confirmDeleteAccount(): Promise<boolean> {
    try {
      const index = await this.$commonDialogs.confirmation.confirmDangerCancel(
        "アカウント削除",
        ["アカウントを削除してもよろしいですか？"],
        "削除する"
      );
      return (index === 0);
    } catch (e) {
      return false;
    }
  }
}
